<ng-content></ng-content>
<div class="wizard__footer">
  <button class="btn btn-w-m btn-default" type="button"
          *ngIf="isOnFirstStep() || isOnSuccessfulRegistrationStep()"
          (click)="router.navigate(['/login'])">
    {{ 'REGISTRATION.NAVIGATION.MAINPAGE' | translate:locale.language }}
  </button>
  <button class="btn btn-w-m btn-danger" type="button"
          *ngIf="isOnFailedRegistrationStep()"
          (click)="router.navigate(['/login'])">
    {{ 'REGISTRATION.NAVIGATION.CANCEL_REGISTRATION' | translate:locale.language }}
  </button>
  <button class="btn btn-w-m btn-warning" type="button"
          *ngIf="isOnConfirmTokenStep() || isOnFailedRegistrationStep()"
          (click)="stepChange.emit( 1)">
    {{ 'REGISTRATION.NAVIGATION.EDIT_DATA' | translate:locale.language }}
  </button>
  <button class="btn btn-w-m btn-default" type="button"
          *ngIf="!isOnFirstStep() && !isOnFailedRegistrationStep() && !isOnSuccessfulRegistrationStep() && !isOnConfirmTokenStep()"
          (click)="stepChange.emit(step - 1)">
    {{ 'REGISTRATION.NAVIGATION.PREVIOUS' | translate:locale.language }}
  </button>
  <div *ngIf="!isOnSuccessfulRegistrationStep() && !isOnFailedRegistrationStep() && !isOnConfirmTokenStep()">
    <b>{{step}} / 4</b>
  </div>
  <button class="btn btn-w-m btn-default" type="button"
          *ngIf="!isOnRequestTokenStep() && !isOnConfirmTokenStep() && !isOnFailedRegistrationStep()"
          [disabled]="!selectedMode"
          [style.visibility]="isOnSuccessfulRegistrationStep() || isOnFailedRegistrationStep()? 'hidden':'visible'"
          [title]="!selectedMode ? ('REGISTRATION.NAVIGATION.INVALID_ACCOUNT_SELECTION' | translate:locale.language):''"
          (click)="stepChange.emit(step + 1)">
    {{ 'REGISTRATION.NAVIGATION.NEXT' | translate:locale.language }}
  </button>
  <button type="button" class="btn btn-w-m btn-success"
          *ngIf="isOnRequestTokenStep()"
          [disabled]="registrationForm.invalid"
          [title]="registrationForm.invalid ? ('REGISTRATION.NAVIGATION.INVALID_TOOLTIP' | translate:locale.language) : ''"
          (click)="this.generateToken(registrationForm.valid)">
    {{ 'REGISTRATION.NAVIGATION.REGISTER' | translate:locale.language }}
  </button>
  <button type="button" class="btn btn-w-m btn-success"
          *ngIf="isOnConfirmTokenStep()"
          [disabled]="registrationForm.invalid || !registrationTokenValid()"
          [title]="!registrationTokenValid() ? ('REGISTRATION.ERRORMESSAGE.REGISTRATION_TOKEN' | translate:locale.language): ''"
          (click)="this.confirmTokenAndRegister(registrationForm)">
    {{ 'REGISTRATION.NAVIGATION.CONFIRM' | translate:locale.language }}
  </button>
  <button class="btn btn-w-m btn-success" type="button"
          *ngIf="isOnFailedRegistrationStep()"
          (click)="this.generateToken(registrationForm.valid)">
    {{ 'REGISTRATION.NAVIGATION.RETRY_TOKEN' | translate:locale.language }}
  </button>
</div>
